import { defineMessages } from 'utils/intl';

export default defineMessages({
  notFoundTip1: 'Sprawdź, czy we wpisanej frazie nie ma błędów (literówek)',
  notFoundTip2: 'Zmień zapytanie, spróbuj wpisać bardziej ogólną frazę',
  phrase: 'Fraza',
  from: 'od',
  to: 'do',
});
